export const SUPPORT_CHAT_POLL_MS = 4000;
export const SUPPORT_CHAT_URL_REFRESH_MS = 5 * 60 * 1000;
export const SUPPORT_CHAT_PAGE_SIZE = 50;

export const MEDIA_LIMITS_MB = {
  image: 10,
  video: 50,
  file: 50,
};

export const MEDIA_ACCEPT = 'image/*,video/*,application/pdf,.doc,.docx,.xls,.xlsx,.txt,.zip,.rar';
